import { render, staticRenderFns } from "./DeepLTranslations.vue?vue&type=template&id=8db700a4&"
import script from "./DeepLTranslations.vue?vue&type=script&lang=js&"
export * from "./DeepLTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports